import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="py-16 md:py-24 px-4 relative overflow-hidden" data-id="element-16">
      <div className="absolute inset-0 bg-brand-blue/5 blur-[120px] pointer-events-none" data-id="element-17" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6" data-id="element-19">
          <p className="text-xl md:text-2xl text-gray-400 font-display font-medium" data-id="element-20">
            Esto no se trata de apostar más.
          </p>

          <h2 className="text-3xl md:text-5xl font-display font-bold leading-tight" data-id="element-21">
            Se trata de{' '}
            <span className="text-brand-green" data-id="element-22">decidir diferente.</span>
          </h2>

          <p className="text-base md:text-lg text-gray-500 italic max-w-xl mx-auto pt-2" data-id="element-23">
            Y una vez ves la estructura… es difícil dejar de verla.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="mt-10" data-id="element-24">
          <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} className="btn-primary w-full md:w-auto px-10 py-5 rounded-2xl font-display font-bold text-lg md:text-xl uppercase tracking-wider inline-flex items-center justify-center" data-id="element-25">
            [ ACCEDER A VISIONGOL ]
          </button>
          <p className="text-gray-500 text-xs font-mono uppercase tracking-wider mt-4" data-id="element-26">
            Entrada inmediata · $6.36 USD
          </p>
        </motion.div>
      </div>
    </section>;
}